export default "__VITE_PUBLIC_ASSET__64d20787__"